import { useQuery } from '@tanstack/react-query'
import { fetchAll } from 'services/plans'

const KEY = 'plans'

export function usePlans(params = {}) {
  return useQuery([KEY, params], () => fetchAll(), {
    select: (data) =>
      data.map((plan) => {
        // console.log(`PLAN :: `,plan)
        if (plan.interval === 'year') {
          const monthlyPrice =
            data.find((p) => p.interval === 'month')?.amount || 0
          const savings = Math.ceil(
            ((monthlyPrice * 12 - plan.amount) / (monthlyPrice * 12)) * 100,
          )
          return {
            ...plan,
            savings,
          }
        } else {
          return plan
        }
      }),
  })
}
